import type { ValidationError } from './validation-error-types';
import { zodIssuesToValidationErrors } from './zod-to-validation-errors';

import { businessDocumentsSchema } from '../../model/schemas';

export function validateBusinessDocuments(
  value: unknown,
  shouldSkipEmpty = true
): ValidationError[] {
  if (!value && shouldSkipEmpty) return [];
  const result = businessDocumentsSchema.safeParse(value);
  if (result.success) return [];
  return zodIssuesToValidationErrors(result.error.issues);
}
